angular.module('content.widgets.SbarWidgetService', [
])

/**
 * The SbarWidgetService service handles scoring and
 * feedback for the state.contentView type
 *
 * @class SbarWidgetService
 * @constructor
 * @module content.widgets.SbarWidgetService
 */
.factory('SbarWidgetService', [
  function () {
    'use strict';

    var service = {

      model: {
        label: 'SBAR Communication Worksheet',
        situation: '',
        background: '',
        assessment: '',
        recommendation: ''
      },

      setModel: function (model) {
        service.model = model;
      },

      setLabel: function (label) {
        service.model.label = label;
      },

      getModel: function () {
        return service.model;
      }
    };

    return service;
  }
]);
